import { Photo } from "./types/photo";
import { PhotoType } from "./types/photoType";

export function getPhotoType(photoTypes: PhotoType[], photo: Photo) {
  if (!photoTypes || !photo) {
    throw new Error("photoTypes or photo can't be empty");
  }

  const matchingPhotoType = photoTypes.find((pt) => pt.id === photo.typeId);
  if (!matchingPhotoType)
    throw new Error(
      `Can't find matching photoType for photo.typeId [${photo.typeId}]`
    );
  return matchingPhotoType;
}
